<h5 *ngIf="showExplanation">Uw aansluitadressen</h5>
<p *ngIf="showExplanation">
  Hier vind je de lijst van uw aansluitadressen. Klik op het EAN-nummer om info
  over het product en de looptijd van het contract op het geselecteerde
  aansluitpunt weer te geven. Klik op 'Toevoegen' om een bijkomend contract aan
  te maken voor dat adres.
</p>
<p-table [value]="contracts">
  <ng-template pTemplate="header">
    <tr>
      <th>Adres</th>
      <th>Nutstype</th>
      <th [class]="showButton ? '' : 'text-align-right'">EAN</th>
      <th [class]="showButton ? 'text-align-right' : ''" *ngIf="showButton">
        Bijkomend contract
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-contract>
    <tr>
      <td>{{ contract.streetName }} {{ contract.houseNumber }}, {{ contract.postalCode }} {{ contract.location }}</td>
      <td>{{ NutsTypeEnum[contract.installationType] }}</td>
      <td [class]="showButton ? '' : 'text-align-right'">{{ contract.ean }}</td>
      <td [class]="showButton ? 'text-align-right' : ''" *ngIf="showButton">
        <p-button
          [outlined]="true"
          [routerLink]="['/customer-wizard/customer', 'step-1']"
          [state]="{ 'customer': { 'streetName': contract.streetName, 'houseNumber': contract.houseNumber, 'postalCode': contract.postalCode, 'location': contract.location }}">+ Toevoegen</p-button>
      </td>
    </tr>
  </ng-template>
</p-table>
<br *ngIf="showButton" />
<p-button
  class="float-right"
  *ngIf="showButton"
  [routerLink]="['/customer-wizard/customer', 'step-1']">Nieuw contract toevoegen op nieuw adres</p-button
>
